import styled from 'styled-components';

import Spinner from '../Spinner';

import {commonPalette} from '../../styles/palette';
import {spacing, cornerRadius} from '../../styles/vars';
import {buttonMetrics} from '../../styles/metrics';

export const ChecklistOverviewWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

type LayoutProps = {
  isDesktop?: boolean;
  showSignature?: boolean;
};

export const StyledForm = styled.form<LayoutProps>`
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: ${({isDesktop}) => (isDesktop ? 'row' : 'column')};
  gap: ${spacing.spacing02};
  padding: 15px;
`;

export const StepsOverviewWrapper = styled.div`
  overflow-y: auto;
  flex: 1;
`;

export const ButtonWrapper = styled.button`
  background-color: ${commonPalette.surfaceBrand};
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};
  border-radius: ${cornerRadius.default}px;
  border: none;
  text-align: center;
  outline: none;
  height: ${buttonMetrics.height}px;
  cursor: ${({disabled}) => (disabled ? '' : 'pointer')};
  z-index: 999;
  pointer-events: all;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledButtonText = styled.div`
  color: ${commonPalette.white};
  font-size: 16px;
  margin: 15px 0;
  text-transform: uppercase;
`;

export const StyledSpinner = styled(Spinner)`
  position: relative;
  margin-left: 20px;
  margin-bottom: 30px;
`;

export const StyledText = styled.div<LayoutProps>`
  padding: 0 0 15px 15px;
  color: ${commonPalette.txLightGrey};
  ${({isDesktop}) => (isDesktop ? 'margin: 15px 0 0 15px;' : '')}
`;

export const StyledWrapper = styled.div<LayoutProps>`
  display: flex;
  ${({isDesktop, showSignature}) =>
    showSignature || !isDesktop ? 'flex-direction: column;' : 'align-items: flex-end; > * { flex: 1; }'}
  gap: ${spacing.spacing02};
  flex: 1;
  z-index: 10;
  position: relative;
`;

export const ClickBlocker = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
`;
